import React, { useState } from 'react';
import { Text, View, TextInput, ActivityIndicator } from 'react-native';
import { useQuery } from '@apollo/client';

import GroupUpdateTypesEnum, { getConfirmationActionText } from './group-update-types-enum';
import { GROUP_QUERY, type GroupQueryResult } from './graphql';
import { ItemSeparatorComponent } from '../../base-components';
import { Button, Error, Popup } from '../../../components';

import styles from './styles';

type Props = {
  groupId: string;
  hidden: boolean;
  cancelAction: () => void;
  whichAction: GroupUpdateTypesEnum | null;
  confirmAction: (newAutolockThreshold: string) => void;
};

const GroupUpdateConfirmation: React.FC<Props> = ({
  hidden,
  groupId,
  whichAction,
  cancelAction,
  confirmAction,
}) => {
  const [group, setGroup] = useState<{ name?: string; autolockThreshold?: number }>({});
  const [newAutolockThreshold, setThreshold] = useState('');

  const { loading, error } = useQuery<GroupQueryResult>(GROUP_QUERY, {
    skip: !groupId,
    variables: { groupId },
    onCompleted: data => {
      if (data.group) {
        setGroup(data.group);
        setThreshold(data.group.autolockThreshold?.toString() || '');
      }
    },
  });

  const groupName = group?.name;

  if (loading) return <ActivityIndicator />;
  if (error) return <Error error={String(error)} />;

  const { textValue, textStyle } = getConfirmationActionText(whichAction);

  return (
    <Popup hidden={hidden} close={() => cancelAction()}>
      <View>
        <Text style={styles.header}>Please confirm action</Text>
        <ItemSeparatorComponent style={styles.separator} />
        <Text>
          You&apos;re about to&nbsp;
          <Text style={[textStyle, styles.fontBold]}>{textValue}</Text>
        </Text>
        <Text> the following team/group:</Text>
        <ItemSeparatorComponent style={styles.separator} />
        <Text style={styles.fontBold}>{groupName}</Text>
        <ItemSeparatorComponent style={styles.separator} />

        {whichAction === GroupUpdateTypesEnum.Threshold && (
          <>
            <View style={styles.row}>
              <TextInput
                style={styles.textInput}
                value={newAutolockThreshold}
                onChangeText={setThreshold}
                placeholder="Max"
              />
            </View>
            <ItemSeparatorComponent style={styles.separator} />
          </>
        )}

        <View style={styles.row}>
          <Button
            // @ts-ignore
            small
            grey
            onClick={cancelAction}
            className="w-25 mx-2"
          >
            Cancel
          </Button>
          <Button
            // @ts-ignore
            small
            action
            className="w-25 mx-2"
            onClick={() => confirmAction(newAutolockThreshold)}
          >
            Confirm
          </Button>
        </View>
      </View>
    </Popup>
  );
};

export default GroupUpdateConfirmation;
